var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-11-05
 * @brief EHP 이메일 상담 관리 개발
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
import { loadingBoxState } from "../../../recoil/menuState";
import { langState } from '../../../recoil/langState';
// utils
import clog from "../../../utils/logUtils";
import * as CONST from "../../../utils/Const";
import * as CUTIL from "../../../utils/commUtils";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
//component
import EhpPagination from "../../common/pagination/EhpPagination";
import { useTrans } from "../../../utils/langs/useTrans";
/**
 * @brief EHP 이메일 상담 관리 - List 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function EconsultList(props) {
    //transe, navigate
    const navigate = useNavigate();
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    //props
    const isMobile = props.isMobile;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    //const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    const setParentNodata = props.handleNodata;
    //
    //
    const [consultList, setConsultList] = useState([]);
    const defaultPageInfo = { "size": 10, "totalElements": 0, "totalPages": 0, "number": 0, "psize": 10, "listReload": false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    // date List
    const consultTypeList = [
        { "id": 0, "ctDisp": "전체", "ctVal": "" },
        { "id": 2, "ctDisp": "e-Health Portal 문의", "ctVal": "CONSULT" },
        { "id": 3, "ctDisp": "기타 문의", "ctVal": "ETC" },
    ];
    const [consultType, setConsultType] = useState(consultTypeList[0]);
    //
    let appPath = "";
    //appPath = 'page=' + pageInfo.number + '&size=' + pageInfo.size;
    /////////////////
    const searchFieldList = [
        { "id": 0, "sfDisp": "제목", "sfVal": "subject" },
        { "id": 1, "sfDisp": "문의내용", "sfVal": "content" },
        { "id": 2, "sfDisp": "답변", "sfVal": "reply" },
    ];
    const [searchField, setSearchField] = useState(searchFieldList[0]);
    const [searchText, setSearchText] = useState("");
    const [searchData, setSearchData] = useState({
        "consultType": null,
        "searchField": null,
        "searchText": "",
    });
    const [fieldList, setFieldList] = useState([
        { "id": 0, "fdDisp": "문의 유형", "fdVal": "consultType", "sort": "asc", "click": false },
        { "id": 1, "fdDisp": "제목", "fdVal": "subject", "sort": null, "click": false },
        { "id": 2, "fdDisp": "이름", "fdVal": "-", "sort": null, "click": false },
        { "id": 3, "fdDisp": "E-mail(ID)", "fdVal": "-", "sort": null, "click": false },
        { "id": 4, "fdDisp": "연락처", "fdVal": "-", "sort": null, "click": false },
        { "id": 5, "fdDisp": "문의일자", "fdVal": "requestedDate", "sort": "asc", "click": false },
        { "id": 6, "fdDisp": "답변여부", "fdVal": "replyYn", "sort": "sort", "click": false },
        { "id": 7, "fdDisp": "답변일자", "fdVal": "responseDate", "sort": "asc", "click": false },
    ]);
    if (searchData.consultType) {
        if (searchData.consultType.ctVal.length > 0) {
            appPath = appPath + `&consultType=${searchData.consultType.ctVal}`;
            //appPath = appPath + `&CONSULT=${searchData.consultType.ctVal}`;
        }
    }
    //text검색
    if (searchData.searchField) {
        if ((searchData.searchField.sfVal.length > 0) && (searchData.searchText.length > 0)) {
            appPath = appPath + `&stringSearch=${searchData.searchField.sfVal}&searchLike=${searchData.searchText}`;
        }
    }
    //필드 정렬
    fieldList.filter(fd => fd.click && fd.sort).map((fd) => {
        appPath = appPath + `&sort=${fd.fdVal},${fd.sort}`;
    });
    clog("IN EHC LIST : APP PATH : " + appPath + " : " + JSON.stringify(pageInfo));
    //clog("IN EHC LIST : SEARCH TEXT : " + searchText);
    const [listReload, setListReload] = useState(false);
    const [errorList, setErrorList] = useState([]);
    /* page 정보 초기화
    useEffect(()=>{
      handleCurPage(0);
    }, [appPath, listReload]);//
    */
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/board/consult?page=${pageInfo.number}&size=${pageInfo.size}&${appPath}`,
        //appPath: `/api/v2/board/consult?${appPath}`,
        appQuery: {
        //"serviceStatus":serviceStatus,
        },
        userToken: userInfo.loginInfo.token,
        watch: pageInfo.number + pageInfo.size + appPath + listReload
        //watch: appPath+listReload
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        if (retData) {
            setRecoilIsLoadingBox(false);
            const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
            if (ERR_URL.length > 0) {
                navigate(ERR_URL);
            }
            //setRecoilIsLoadingBox(false);
            if (retData.codeNum == CONST.API_200) {
                clog("IN WF EHC COUNT : RES : " + JSON.stringify(retData.data.page));
                setParentNodata(retData.data.page);
                setPageInfo(Object.assign(Object.assign({}, retData.data.page), { psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, "listReload": false })); //5, 10
                setConsultList(retData.body);
                setListReload(false);
            }
        }
    }, [retData]);
    //////////////////
    // option 선택 시  값 변경 액션
    function selectOptionConsultType(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        setConsultType(JSON.parse(optionData));
        // init
    }
    // option 선택 시  값 변경 액션
    // option 선택 시  값 변경 액션
    function selectOptionSearchField(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        //
        var sf = JSON.parse(optionData);
        if (sf.sfVal.length <= 0)
            setSearchText("");
        setSearchField(JSON.parse(optionData));
        //
    }
    function onClickSortField(fieldVal) {
        handleCurPage(0);
        //setConsultList([]);
        setFieldList(fieldList.map(fd => (fd.fdVal === fieldVal)
            ? Object.assign(Object.assign({}, fd), { "sort": (fd.sort === "asc") ? "desc" : "asc", "click": true }) : Object.assign(Object.assign({}, fd), { "sort": "asc", "click": false })) // 단일 필드 정렬만....
        );
        //handleCurPage(0);
    }
    function onClickSearch(e) {
        goSearch(e);
    }
    function goSearch(e) {
        clog("goSearch : " + JSON.stringify(searchField));
        handleCurPage(0);
        setSearchData({
            "consultType": consultType,
            "searchField": searchField,
            "searchText": searchText,
        });
    }
    function onClickAnswerOk(e, consult) {
        e.stopPropagation();
        //e.preventDefault();
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-answer-ok");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "730");
        setParentPopWin("pop-answer-ok", React.createElement(MobileEmailConsultAnswerOk, { htmlHeader: React.createElement("h1", null, "\uB2F5\uBCC0\uD558\uAE30"), consultInfo: consult, setPopWin: props.setPopWin }));
        CUTIL.jsopen_Popup(e);
    }
    const [winCountReply, setWinCountReply] = useState(0);
    function onClickAnswer(e, consult) {
        e.stopPropagation();
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-answer");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "730");
        setParentPopWin("pop-answer", React.createElement(MobileEmailConsultAnswer, { htmlHeader: React.createElement("h1", null, "\uB2F5\uBCC0\uD558\uAE30"), consultInfo: consult, listReload: listReload, setListReload: setListReload, winCountReply: winCountReply + 1, setWinCountReply: setWinCountReply, setPopWin: props.setPopWin }));
        CUTIL.jsopen_Popup(e);
        setWinCountReply(winCountReply + 1);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right w100p" },
            React.createElement("h2", { className: "mb-0 ml-8 font-20" }, "\uC774\uBA54\uC77C \uC0C1\uB2F4"),
            React.createElement("div", { className: "search pt-28 pb-26" },
                React.createElement("ul", { className: "form__input" },
                    React.createElement("li", null,
                        React.createElement("label", { htmlFor: "f1" }, "\uBB38\uC758 \uC720\uD615"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("div", { className: "select w186", onClick: (e) => CUTIL.onClickSelect(e, selectOptionConsultType) },
                                React.createElement("div", { className: "selected" },
                                    React.createElement("div", { className: "selected-value" }, consultTypeList[0].ctDisp),
                                    React.createElement("div", { className: "arrow" })),
                                React.createElement("ul", null, consultTypeList.map((ctype, idx) => (React.createElement("li", { key: `li_${idx.toString()}`, className: "option", "data-value": JSON.stringify(ctype) }, ctype.ctDisp))))))))),
            React.createElement("div", { className: "tbl__top mb-16 mt-36" },
                React.createElement("div", { className: "right" },
                    React.createElement("div", { className: "searcharea" },
                        React.createElement("div", { className: "searchinput" },
                            React.createElement("span", null, "\uAC80\uC0C9"),
                            React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, selectOptionSearchField) },
                                React.createElement("div", { className: "selected" },
                                    React.createElement("div", { className: "selected-value" }, searchFieldList[0].sfDisp),
                                    React.createElement("div", { className: "arrow" })),
                                React.createElement("ul", null, searchFieldList.map((slist, idx) => React.createElement("li", { key: `li_${idx.toString()}`, className: "option", "data-value": JSON.stringify(slist) }, slist.sfDisp)))),
                            React.createElement("div", { className: "input__direct" },
                                React.createElement("input", { type: "text", placeholder: "\uAC80\uC0C9\uC5B4\uB97C \uC785\uB825\uD558\uC138\uC694", value: searchText, onChange: (e) => setSearchText(e.target.value) }),
                                (searchText.length > 0) && React.createElement("button", { type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") },
                                    React.createElement("span", { className: "hide" }, "\uC785\uB825 \uCC3D \uB2EB\uAE30")))),
                        React.createElement("button", { type: "button", className: "btn-search", onClick: (e) => onClickSearch(e) },
                            React.createElement("span", null, "\uC870\uD68C"))))),
            React.createElement("p", { className: "nodata__txt" }, t("MESSAGE.데이터를찾을수없습니다")),
            React.createElement("div", { className: "tbl-list checksheet-list hcal-270 " },
                React.createElement("table", { summary: "\uBB38\uC758 \uC720\uD615,\uC81C\uBAA9,\uC774\uB984,E-mail(ID),\uC5F0\uB77D\uCC98,\uBB38\uC758\uC77C\uC790,\uB2F5\uBCC0\uC5EC\uBD80,\uB2F5\uBCC0\uC77C\uC790 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC774\uBA54\uC77C \uC0C1\uB2F4\uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uC774\uBA54\uC77C \uC0C1\uB2F4\uB9AC\uC2A4\uD2B8"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: { "width": "12%" } }),
                        React.createElement("col", { style: { "width": "32%" } }),
                        React.createElement("col", { style: { "width": "7%" } }),
                        React.createElement("col", { style: { "width": "17%" } }),
                        React.createElement("col", { style: { "width": "8%" } }),
                        React.createElement("col", { style: { "width": "8%" } }),
                        React.createElement("col", { style: { "width": "7%" } }),
                        React.createElement("col", { style: { "width": "8%" } })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "consultType").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} txt-left`, onClick: (e) => onClickSortField("consultType") },
                                React.createElement("span", null, "\uBB38\uC758 \uC720\uD615")),
                            React.createElement("th", { scope: "col", className: "txt-left" },
                                React.createElement("span", null, "\uC81C\uBAA9")),
                            React.createElement("th", { scope: "col", className: "txt-left" },
                                React.createElement("span", null, "\uC774\uB984")),
                            React.createElement("th", { scope: "col", className: "txt-left" },
                                React.createElement("span", null, "E-mail(ID)")),
                            React.createElement("th", { scope: "col", className: "txt-left" },
                                React.createElement("span", null, "\uC5F0\uB77D\uCC98")),
                            React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "requestedDate").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} txt-left`, onClick: (e) => onClickSortField("requestedDate") },
                                React.createElement("span", null, "\uBB38\uC758\uC77C\uC790")),
                            React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "replyYn").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} txt-left`, onClick: (e) => onClickSortField("replyYn") },
                                React.createElement("span", null, "\uB2F5\uBCC0\uC5EC\uBD80")),
                            React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "responseDate").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} txt-left`, onClick: (e) => onClickSortField("responseDate") },
                                React.createElement("span", null, "\uB2F5\uBCC0\uC77C\uC790")))),
                    React.createElement("tbody", null, consultList.map((consult, idx) => (React.createElement("tr", { key: `tr_${idx.toString()}` },
                        React.createElement("td", { className: "txt-left" }, consult.consultType),
                        React.createElement("td", { className: "txt-left" },
                            React.createElement("p", { className: "ellipsis" }, consult.subject)),
                        React.createElement("td", { className: "txt-left" }, consult.user.name),
                        React.createElement("td", { className: "txt-left" },
                            React.createElement("p", { className: "ellipsis" }, consult.user.userId)),
                        React.createElement("td", { className: "txt-left" }, consult.user.phoneNumber),
                        React.createElement("td", { className: "txt-left" }, CUTIL.utc2formedstr(consult.requestedDate, "yyyy-MM-DD")),
                        React.createElement("td", { className: "txt-left" }, (consult.replyYn)
                            ? React.createElement("button", { type: "button", className: "bg-gray js-open", "data-pop": "pop-answer-ok", onClick: (e) => onClickAnswerOk(e, consult) },
                                React.createElement("span", null, "\uB2F5\uBCC0 \uC644\uB8CC"))
                            : React.createElement("button", { type: "button", className: "bg-blue js-open", "data-pop": "pop-answer", onClick: (e) => onClickAnswer(e, consult) },
                                React.createElement("span", null, "\uB2F5\uBCC0\uD558\uAE30"))),
                        React.createElement("td", { className: "txt-left" }, CUTIL.utc2formedstr(consult.responseDate, "yyyy-MM-DD")))))))),
            React.createElement(EhpPagination, { componentName: "Econsult", pageInfo: pageInfo, handleFunc: handleCurPage }))));
}
;
export default EconsultList;
function MobileEmailConsultAnswerOk(props) {
    //trans
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props
    const consultInfo = props.consultInfo;
    const setParentPopWin = props.setPopWin;
    //clog("MobileEmailConsultAnswerOk : " + JSON.stringify(consultInfo));
    ///
    const [consultDetail, setConsultDetail] = useState(null);
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/board/consult/${consultInfo.consultId}`,
        appQuery: {
        //"serviceStatus":serviceStatus,
        },
        userToken: userInfo.loginInfo.token,
        watch: consultInfo.consultId
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        if (retData) {
            setRecoilIsLoadingBox(false);
            /*
            const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
            if (ERR_URL.length > 0) {
              navigate(ERR_URL);
            }
            */
            //clog("IN WF EHC COUNT : RES : " + JSON.stringify(retData.body));
            if (retData.codeNum == CONST.API_200) {
                //setParentNodata(retData.data.page);
                setConsultDetail(retData.body);
                //setPageInfo({ ...retData.data.page, psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, "listReload":false},); //5, 10
            }
        }
    }, [retData]);
    //////////////////
    function onClickFileDownload(e, file) {
        HTTPUTIL.fileDownload(decodeURI(file.name), file.url);
    }
    function onClickClose(e) {
        CUTIL.jsclose_Popup("pop-answer-ok");
        setParentPopWin("pop-answer-ok", null);
    }
    return (React.createElement(React.Fragment, null, (consultDetail) && React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC720\uD615"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", value: consultDetail.consultType, disabled: true }))),
                React.createElement("li", { className: "mt-8" },
                    React.createElement("p", { className: "tit" }, "\uC81C\uBAA9"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", value: consultDetail.subject, disabled: true }))),
                React.createElement("li", { className: "mt-8" },
                    React.createElement("p", { className: "tit" }, "\uC774\uB984"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", value: consultDetail.userName, disabled: true }))),
                React.createElement("li", { className: "mt-8" },
                    React.createElement("p", { className: "tit" }, "Email"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", value: consultDetail.email, disabled: true })))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", { className: "column" },
                    React.createElement("div", { className: "inline left-right w100p" },
                        React.createElement("p", { className: "tit" }, "\uBB38\uC758 \uB0B4\uC6A9"),
                        React.createElement("p", { className: "font-14" }, CUTIL.utc2formedstr(consultDetail.requestedDate, "yyyy-MM-DD"))),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { className: "h128 line-h22", value: consultDetail.content, readOnly: true }))),
                React.createElement("li", { className: "sub-input mt-8" },
                    React.createElement("p", { className: "tit w60 mt-3" }, "\uCCA8\uBD80\uD30C\uC77C"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("ul", { className: "filelist w100p m-0" }, consultDetail.files.map((file, idx) => (React.createElement("li", { key: `li_${idx.toString()}`, onClick: (e) => onClickFileDownload(e, file) },
                            React.createElement("span", null, file.name)))))))),
            React.createElement("ul", { className: "form__input mb-0" },
                React.createElement("li", { className: "column" },
                    React.createElement("div", { className: "inline left-right w100p" },
                        React.createElement("p", { className: "tit" }, "\uB2F5\uBCC0 \uC791\uC131"),
                        React.createElement("p", { className: "font-14" }, CUTIL.utc2formedstr(consultDetail.responseDate, "yyyy-MM-DD"))),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { className: "h128 line-h22", value: consultDetail.reply, readOnly: true }))),
                React.createElement("li", { className: "sub-input mt-8" },
                    React.createElement("p", { className: "tit w60 mt-10" }, "\uCCA8\uBD80\uD30C\uC77C"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("ul", { className: "filelist w100p mt-10" }, consultDetail.replyFiles.map((file, idx) => (React.createElement("li", { key: `li_${idx.toString()}`, onClick: (e) => onClickFileDownload(e, file) },
                            React.createElement("span", null, file.name))))))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", onClick: (e) => onClickClose(e) },
                React.createElement("span", null, "\uD655\uC778"))))));
}
function MobileEmailConsultAnswer(props) {
    //trans, navigate, ref
    const t = useTrans();
    const fileRef = useRef();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props
    const consultInfo = props.consultInfo;
    const listReload = props.listReload;
    const setParentListReload = props.setListReload;
    const winCountReply = props.winCountReply;
    const setParentWinCountReply = props.setWinCountReply;
    const setParentPopWin = props.setPopWin;
    //clog("MobileEmailConsultAnswer : " + JSON.stringify(consultInfo));
    ///
    const [errorList, setErrorList] = useState([]);
    const [consultDetail, setConsultDetail] = useState(null);
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/board/consult/${consultInfo.consultId}`,
        appQuery: {
        //"serviceStatus":serviceStatus,
        },
        userToken: userInfo.loginInfo.token,
        watch: consultInfo.consultId
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        if (retData) {
            setRecoilIsLoadingBox(false);
            /*
            const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
            if (ERR_URL.length > 0) {
              navigate(ERR_URL);
            }
            */
            //clog("IN WF EHC COUNT : RES : " + JSON.stringify(retData.body));
            if (retData.codeNum == CONST.API_200) {
                //setParentNodata(retData.data.page);
                setConsultDetail(retData.body);
                setParentWinCountReply(0);
                //setPageInfo({ ...retData.data.page, psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, "listReload":false},); //5, 10
            }
        }
    }, [retData]);
    //////////////////
    function onClickFileDownload(e, file) {
        HTTPUTIL.fileDownload(decodeURI(file.name), file.url);
    }
    function onClickClose(e) {
        //setParentListReload(true);
        CUTIL.jsclose_Popup("pop-answer");
        setReply("");
        setReplyFiles([]);
        setErrorList([]);
        setParentPopWin("pop-answer", null);
    }
    const [reply, setReply] = useState("");
    function handleSetReply(e) {
        setErrorList([]);
        setReply(e.target.value);
    }
    const [replyFiles, setReplyFiles] = useState([]);
    useEffect(() => {
        //    setReply("");
        //setErrorList([]);
    }, [listReload]);
    useEffect(() => {
        //    setReply("");
        setErrorList([]);
    }, [winCountReply, consultInfo]);
    function handleFileUpload(e) {
        fileRef.current.click();
    }
    function onClickDelAddedFile(e, dfile) {
        setReplyFiles(//file.url is unique??
        replyFiles.filter((file) => (file.imageId !== dfile.imageId) && (file.name !== dfile.name)));
    }
    function saveFileImage(e) {
        clog("save attach file : " + JSON.stringify(e.target.files.length));
        const files = e.target.files;
        var formData = new FormData();
        formData.append("files", files[0]);
        var fileVal = {
            imageId: "INS_" + replyFiles.length,
            name: files[0].name,
            url: URL.createObjectURL(files[0]),
            type: "INS",
            fileForm: formData,
            srcFile: files[0],
        };
        if (replyFiles.length <= 9) {
            setReplyFiles([...replyFiles, fileVal]);
            e.target.value = ''; // file name 초기화
        }
        else {
            alert("첨부파일은 10개 까지 가능합니다.");
        }
    }
    ;
    function onclickDoSaveReply(e) {
        return __awaiter(this, void 0, void 0, function* () {
            var isOk = confirm(`답변내용을 전송하시겠습니까?`);
            if (!isOk)
                return;
            setRecoilIsLoadingBox(true);
            let mpartData = new FormData();
            const replyData = {
                "userIdPk": consultDetail.userIdPk,
                "consultId": consultDetail.consultId,
                "reply": reply,
            };
            const blob = new Blob([JSON.stringify(replyData)], { type: "application/json" });
            mpartData.append("replyDtoIn", blob);
            // 또는  formData.append("data", JSON.stringify(value)); 
            // JSON 형식으로 파싱.(백엔드의 요청에 따라 전송방식이 달라진다.)
            replyFiles.map((file) => {
                mpartData.append("files", file.srcFile);
            });
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "POSTF",
                "appPath": "/api/v2/board/consult/reply",
                appQuery: mpartData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                setRecoilIsLoadingBox(false);
                clog("IN E CONSULT: onclickDoSaveReply : " + JSON.stringify(data));
                if (data.codeNum == CONST.API_200) {
                    CUTIL.jsclose_Popup("pop-answer");
                    setParentListReload(true);
                    document.location.reload();
                }
                else { // api if
                    // need error handle
                    alert(data.errorList.map((err) => err.msg));
                    if (data.body.errorList)
                        setErrorList(data.body.errorList);
                }
            }
            //return data;
        });
    }
    clog("ERROR LIST : " + JSON.stringify(errorList));
    return (React.createElement(React.Fragment, null, (consultDetail) && React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC720\uD615"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", value: consultDetail.consultType, disabled: true }))),
                React.createElement("li", { className: "mt-8" },
                    React.createElement("p", { className: "tit" }, "\uC81C\uBAA9"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", value: consultDetail.subject, disabled: true }))),
                React.createElement("li", { className: "mt-8" },
                    React.createElement("p", { className: "tit" }, "\uC774\uB984"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", value: consultDetail.userName, disabled: true }))),
                React.createElement("li", { className: "mt-8" },
                    React.createElement("p", { className: "tit" }, "Email"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", value: consultDetail.email, disabled: true })))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", { className: "column" },
                    React.createElement("div", { className: "inline left-right w100p" },
                        React.createElement("p", { className: "tit" }, "\uBB38\uC758 \uB0B4\uC6A9"),
                        React.createElement("p", { className: "font-14" }, CUTIL.utc2formedstr(consultDetail.requestedDate, "yyyy-MM-DD"))),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { className: "h128 line-h22", value: consultDetail.content, readOnly: true }))),
                React.createElement("li", { className: "sub-input mt-8" },
                    React.createElement("p", { className: "tit w60 mt-3" }, "\uCCA8\uBD80\uD30C\uC77C"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("ul", { className: "filelist w100p m-0" }, consultDetail.files.map((file, idx) => (React.createElement("li", { key: `li_${idx.toString()}`, onClick: (e) => onClickFileDownload(e, file) },
                            React.createElement("span", null, file.name)))))))),
            React.createElement("ul", { className: "form__input mb-0" },
                React.createElement("li", { className: "column" },
                    React.createElement("p", { className: "tit" }, "\uB2F5\uBCC0 \uC791\uC131"),
                    React.createElement("p", { className: "txtnum inline right" }, `${reply.length} / 1000`),
                    React.createElement("div", { className: "input__area mt-0" },
                        React.createElement("textarea", { className: `h128 line-h22 ${(errorList.filter(err => (err.field === "reply")).length > 0) ? "input-error" : ""}`, value: reply, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 1000), onKeyUp: (e) => CUTIL.afterHandleComment(e, 1000, handleSetReply), onChange: (e) => handleSetReply(e) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "reply")).map((err) => err.msg)),
                        React.createElement("p", { className: "txtnum inline left" }, "* \uCCA8\uBD80\uD30C\uC77C\uC740 10\uAC1C \uC774\uD558, \uC804\uCCB4 20M\uAE4C\uC9C0 \uAC00\uB2A5\uD569\uB2C8\uB2E4."))),
                React.createElement("li", { className: "sub-input mt-8" },
                    React.createElement("p", { className: "tit w60 mt-10" }, "\uCCA8\uBD80\uD30C\uC77C"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("div", { className: "filebox" },
                            React.createElement("input", { className: "upload-name", placeholder: "\uD30C\uC77C\uC744 \uCCA8\uBD80\uD558\uC138\uC694", readOnly: true }),
                            React.createElement("label", { onClick: (e) => handleFileUpload(e) },
                                React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uCC3E\uAE30")),
                            React.createElement("input", { type: "file", id: "file", ref: fileRef, accept: "*/*", multiple: true, style: { display: "none" }, onChange: (e) => saveFileImage(e) })),
                        React.createElement("ul", { className: "filelist w100p mt-10" }, replyFiles.map((file, idx) => (React.createElement("li", { key: `li_${idx.toString()}` },
                            React.createElement("span", null, file.name),
                            React.createElement("button", { type: "button", className: "btn btn-delete", onClick: (e) => onClickDelAddedFile(e, file) },
                                React.createElement("span", { className: "hide" }, "\uC0AD\uC81C")))))))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close", onClick: (e) => onClickClose(e) },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", className: "js-open", "data-pop": "pop-send", onClick: (e) => onclickDoSaveReply(e) },
                React.createElement("span", null, "\uC804\uC1A1"))))));
}
